var render, staticRenderFns
import script from "./CustomList.vue?vue&type=script&lang=js&"
export * from "./CustomList.vue?vue&type=script&lang=js&"
import style0 from "./CustomList.vue?vue&type=style&index=0&id=24c41850&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c41850",
  null
  
)

export default component.exports